var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18 8.19H15.11C12.74 8.19 10.81 6.26 10.81 3.89V1C10.81 0.45 10.36 0 9.81 0H5.57C2.49 0 0 2 0 5.57V14.43C0 18 2.49 20 5.57 20H13.43C16.51 20 19 18 19 14.43V9.19C19 8.64 18.55 8.19 18 8.19Z",
    fill: "#35446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 0.210481C12.89 -0.199519 12.18 0.0804814 12.18 0.650481V4.14048C12.18 5.60048 13.42 6.81048 14.93 6.81048C15.88 6.82048 17.2 6.82048 18.33 6.82048C18.9 6.82048 19.2 6.15048 18.8 5.75048C17.36 4.30048 14.78 1.69048 13.3 0.210481Z",
    fill: "#35446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.75H5C4.59 11.75 4.25 11.41 4.25 11C4.25 10.59 4.59 10.25 5 10.25H11C11.41 10.25 11.75 10.59 11.75 11C11.75 11.41 11.41 11.75 11 11.75Z",
    fill: "#35446F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.75H5C4.59 15.75 4.25 15.41 4.25 15C4.25 14.59 4.59 14.25 5 14.25H9C9.41 14.25 9.75 14.59 9.75 15C9.75 15.41 9.41 15.75 9 15.75Z",
    fill: "#35446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.f4f09e49948ccb1666566dbd82b45204.svg";
export { ForwardRef as ReactComponent };